import type { NpvrEvent, NpvrInfo, TrickModes } from '@norlys-a-s/norlys-play-kmm';

import { NpvrEventInfo, NpvrEventItem, NpvrTrickModes } from '@smart-tv/typings/npvr';

export const mapTrickModes = (trickModes: TrickModes): NpvrTrickModes => ({
  allowStartOver: trickModes.allowStartOver,
  allowStartOverPause: trickModes.allowStartOverPause,
  allowStartOverRewind: trickModes.allowStartOverRewind,
  allowStartOverFastForward: trickModes.allowStartOverFastForward,
  allowCatchUp: trickModes.allowCatchUp,
  allowCatchUpPause: trickModes.allowCatchUpPause,
  allowCatchUpRewind: trickModes.allowCatchUpRewind,
  allowCatchUpFastForward: trickModes.allowCatchUpFastForward,
  bitmask: trickModes.bitmask
});

export const mapNpvrInfo = (npvrInfo: NpvrInfo): NpvrEventInfo => ({
  mediaId: npvrInfo.mediaId ?? null,
  trickModes: npvrInfo.trickModes ? mapTrickModes(npvrInfo.trickModes) : null,
  extendNpvrEventWithinSeconds: npvrInfo.extendNpvrEventWithinSeconds ?? null,
  expireTimeEpochSeconds: npvrInfo.expireTimeEpochSeconds ?? null,
  recordedTimeEpochSeconds: npvrInfo.recordedTimeEpochSeconds ?? null,
  isCustomerRecording: npvrInfo.isCustomerRecording ?? null,
  isSeriesRecording: npvrInfo.isSeriesRecording ?? null,
  isNotSeen: npvrInfo.isNotSeen ?? null,
  isEnoughSpaceForRecording: npvrInfo.isEnoughSpaceForRecording ?? null,
  isNpvrExtendAllowed: npvrInfo.isNpvrExtendAllowed ?? null,
  recordingStatus: npvrInfo.recordingStatus ?? null,
  expiresSoon: npvrInfo.expiresSoon
});

export const mapNpvrEvent = (event: NpvrEvent): NpvrEventItem => ({
  channelIcon: event.channelIcon ?? null,
  channelName: event.channelName ?? null,
  coverImageUrl: event.coverImageUrl,
  customerRecordingError: event.customerRecordingError,
  endTimeUtcSeconds: event.endTimeUtcSeconds,
  episodeTitle: event.episodeTitle ?? null,
  errorMessage: event.errorMessage,
  eventId: event.eventId,
  eventLength: event.eventLength,
  mainGenreId: event.mainGenreId,
  metadataEpisodeNo: event.metadataEpisodeNo ?? null,
  metadataSeasonId: event.metadataSeasonId ?? null,
  metadataSeasonNo: event.metadataSeasonNo ?? null,
  metadataSeasonTitle: event.metadataSeasonTitle ?? null,
  metadataSerieId: event.metadataSerieId ?? null,
  npvrExtendDurationInSec: event.npvrExtendDurationInSec,
  npvrInfo: event.npvrInfo ? mapNpvrInfo(event.npvrInfo) : null,
  npvrMediaId: event.npvrMediaId ?? null,
  npvrRecordingHasBeenExtended: event.npvrRecordingHasBeenExtended,
  npvrRecordingHasBeenExtendedCount: event.npvrRecordingHasBeenExtendedCount,
  npvrTrickModes: event.npvrTrickModes ? mapTrickModes(event.npvrTrickModes) : null,
  programDesc: event.programDesc,
  programId: event.programId,
  progressInSeconds: event.progressInSeconds,
  readableDuration: event.readableDuration ?? null,
  readableExpireTime: event.readableExpireTime ?? null,
  readableRecordingTime: event.readableRecordingTime ?? null,
  recordingExpireAtUtcSeconds: event.recordingExpireAtUtcSeconds,
  recordingId: event.recordingId,
  recordingStatus: event.recordingStatus,
  recordingWatched: event.recordingWatched,
  serieId: event.serieId ?? null,
  serieTitle: event.serieTitle ?? null,
  sid: event.sid,
  startTimeUtcSeconds: event.startTimeUtcSeconds,
  title: event.title
});
